
import { useNavigate } from 'react-router-dom'

export const useRedirect = () => {

    const navigate = useNavigate()

    //👉El objeto "state" sirve para enviar props cuando se navega entre rutas

    const redirectTo = (path, state = {}) => {
        if (!path) return
        
        navigate(path , {state})
    }

    return { redirectTo }

}
